<template>
    <app-layout title="Nastavení">

        <settings-tabs-navigation/>

        <div class="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">


            <jet-form-section @submitted="saveSettings(settingsNotificationsMessages)" :working="settingsNotificationsMessages.processing">
                <template #title>
                    Upozornění na zprávy
                </template>
                <template #description>
                    Zde si můžete změnit nastavení týkající upozornění na doručovené zprávy.
                </template>
                <template #form>
                    <div class="mt-4 space-y-4 col-span-6">
                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input v-model="settingsNotificationsMessages.settings.seven_days_notif" id="bg_download_notif" name="bg_download_notif" type="checkbox" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="bg_download_notif" class="font-medium text-gray-700">Týden nepřečtené zprávy</label>
                                <p class="text-gray-500">Chci dostat emailem upozornění na více než týden starou nepřečtenou příchozí zprávu.</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input v-model="settingsNotificationsMessages.settings.bg_download_notif" id="initial_import" name="initial_import" type="checkbox" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="initial_import" class="font-medium text-gray-700">Příchozí zprávy v nepřítomnosti</label>
                                <p class="text-gray-500">Chci dostávat emailem upozornění na zprávy stažené v mé nepřítomnosti.</p>
                            </div>
                        </div>


                    </div>
                </template>
                <template #actions>
                    <jet-action-message :on="settingsNotificationsMessages.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsNotificationsMessages.processing }" :disabled="settingsNotificationsMessages.processing">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>

            <jet-section-border />


            <jet-form-section @submitted="saveSettings(settingsNotificationsPromo)" :working="settingsNotificationsPromo.processing">
                <template #title>
                    Obchodní sdělení, nabídky a akce
                </template>
                <template #description>
                    Zde najdete nastavení upozornění marketingového charakteru a informací o novinkách v DSchránce.
                </template>
                <template #form>
                    <div class="mt-4 space-y-4 col-span-6">

                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input v-model="settingsNotificationsPromo.settings.promos_notif" id="promos_notif" name="promos_notif" type="checkbox" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="promos_notif" class="font-medium text-gray-700">Marketingová sdělení a nabídky</label>
                                <p class="text-gray-500">Chci dostávat obchodní sdělení, a speciální nabídky.</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input v-model="settingsNotificationsPromo.settings.features_notif" id="features_notif" name="features_notif" type="checkbox" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="features_notif" class="font-medium text-gray-700">Novinky a funkce</label>
                                <p class="text-gray-500">Chci dostávat shrnutí změn v DSchránce a upozornění na nové funkce.</p>
                            </div>
                        </div>


                    </div>
                </template>
                <template #actions>
                    <jet-action-message :on="settingsNotificationsPromo.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsNotificationsPromo.processing }" :disabled="settingsNotificationsPromo.processing">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>



            <jet-section-border />


            <jet-form-section @submitted="saveSettings(settingsNotificationsSystem)" :working="settingsNotificationsSystem.processing">
                <template #title>
                    Systémová upozornění
                </template>
                <template #description>
                    Zde si můžete zvolit, jaká systémová upozornění a upozornění technického charakteru Vás zajímají.
                </template>
                <template #form>
                    <div class="mt-4 space-y-4 col-span-6">

                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input v-model="settingsNotificationsSystem.settings.quota_notif" id="quota_notif" name="quota_notif" type="checkbox" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="promos_notif" class="font-medium text-gray-700">Plné úložiště</label>
                                <p class="text-gray-500">Chci dostat upozornění, když využití mé schránky překročí 90%.</p>
                            </div>
                        </div>
                    </div>
                </template>
                <template #actions>
                    <jet-action-message :on="settingsNotificationsSystem.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsNotificationsSystem.processing }" :disabled="settingsNotificationsSystem.processing">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>

        </div>


    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDangerButton from '@/Jetstream/DangerButton'
import SettingsTabsNavigation from "./SettingsTabsNavigation";

export default {
    name: "SettingsNotifications",
    components: {
        SettingsTabsNavigation,
        AppLayout,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetDangerButton,
    },
    data() {
        return {
            settingsNotificationsMessages: this.$inertia.form({
                referer: 'settingsNotif',
                settings: {
                    seven_days_notif: !!this.$page.props.settingsDS.seven_days_notif,
                    bg_download_notif: !!this.$page.props.settingsDS.bg_download_notif,
                }
            }),
            settingsNotificationsPromo: this.$inertia.form({
                referer: 'settingsNotif',
                settings: {
                    promos_notif: !!this.$page.props.settingsDS.promos_notif,
                    features_notif: !!this.$page.props.settingsDS.features_notif
                }
            }),
            settingsNotificationsSystem: this.$inertia.form({
                referer: 'settingsNotif',
                settings: {
                    quota_notif: !!this.$page.props.settingsDS.quota_notif,
                }
            }),

        }
    },
    methods: {
        saveSettings(settings){
            settings.post(route('settings'), {
                preserveScroll: true
            });
        }
    },
}
</script>

<style scoped>

</style>
